import React from 'react';
import { Field } from 'react-final-form';
import DateRangeController from './DateRangeController';

const component = props => {
  const { input, controllerRef, ...rest } = props;
  const { type, ...restOfInput } = input;
  return <DateRangeController ref={controllerRef} {...restOfInput} {...rest} />;
};

const FieldDateRangeController = props => {
  return <Field component={component} {...props} />;
};

export default FieldDateRangeController;
